import {Injectable} from "@angular/core";
import {ApiService} from "app/services/domain/api.service";
import * as Models from "app/services/proxy/model/models";
import {Lookup} from "framework/services/utils.service";

@Injectable()
export class ComplianceAssessmentFiltersService
{
    private readonly m_filtersByKey: Lookup<Models.ComplianceAssessmentSummaryDetail[]>          = {};
    private readonly m_fetchingByKey: Lookup<Promise<Models.ComplianceAssessmentSummaryDetail[]>> = {};

    constructor(private m_api: ApiService)
    {}

    public async getFilters(tenantIds: string[],
                            includeAllStandards: boolean = false): Promise<Models.ComplianceAssessmentSummaryDetail[]>
    {
        const key = ComplianceAssessmentFiltersService.buildCacheKey(tenantIds, includeAllStandards);

        if (this.m_filtersByKey[key])
        {
            return this.m_filtersByKey[key];
        }

        if (!this.m_fetchingByKey[key])
        {
            this.m_fetchingByKey[key] = (async () =>
            {
                try
                {
                    const request = Models.ComplianceAssessmentSummaryDetailRequest.newInstance({
                                                                                                    tenant_ids           : tenantIds,
                                                                                                    include_all_standards: includeAllStandards
                                                                                                });
                    this.m_filtersByKey[key] = await this.m_api.compliance.complianceAssessmentFilter(request) || [];
                }
                finally
                {
                    delete this.m_fetchingByKey[key];
                }

                return this.m_filtersByKey[key];
            })();
        }

        return this.m_fetchingByKey[key];
    }

    public resetTenantCache(tenantId: string): void
    {
        for (const key of Object.keys(this.m_filtersByKey))
        {
            const tenantsKey = key.split("|||")[0];
            if (tenantsKey.split(",")
                          .includes(tenantId))
            {
                delete this.m_filtersByKey[key];
            }
        }
    }

    private static buildCacheKey(tenantIds: string[],
                                 includeAllStandards: boolean): string
    {
        const tenantsKey = (tenantIds || []).slice()
                                            .sort()
                                            .join(",");

        return `${tenantsKey}|||${includeAllStandards ? "all" : "default"}`;
    }
}
